import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const DayRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    padding: 12px 0;
    border-top: 1px solid ${colors.borderSofter};
`;

export const DaySwitch = styled.div`
    flex: 1 1 190px;
    min-width: 0;
`;

export const TimeRange = styled.div`
    flex: 1 1 300px;
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const RangeField = styled.div`
    flex: 1;
`;

export const Dash = styled.span`
    color: ${colors.textSecondary};
`;
